import EditParticularPatient from "./editParticularPatient";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
};

const EditParticularPatientModal = ({
  toggleModal,
  urlTittle,
}: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={`Editar Información del paciente`}
        titleStyle={styles}
        urlTittle={urlTittle}
      >
        <EditParticularPatient />
      </Modal>
    </>
  );
};

export default EditParticularPatientModal;
